/**
 * i18next backend: one async chunk per locale JSON (Vite import.meta.glob).
 * Bootstrap namespaces (common, auth, shop) stay eager in config.js.
 */

export const LAZY_LOCALE_NAMESPACES = [
  'admin',
  'dashboard',
  'playlists',
  'roles',
  'user',
  'storage',
  'cookies',
  'home',
  'artist',
  'payment',
  'manager',
  'onboarding',
];

const localeModules = import.meta.glob([
  '../locales/*/admin.json',
  '../locales/*/dashboard.json',
  '../locales/*/playlists.json',
  '../locales/*/roles.json',
  '../locales/*/user.json',
  '../locales/*/storage.json',
  '../locales/*/cookies.json',
  '../locales/*/home.json',
  '../locales/*/artist.json',
  '../locales/*/payment.json',
  '../locales/*/manager.json',
  '../locales/*/onboarding.json',
]);

const localeKey = (language, namespace) => {
  const lng = String(language || 'pl').split('-')[0];
  return `../locales/${lng}/${namespace}.json`;
};

export function loadLocaleNamespace(language, namespace) {
  const key = localeKey(language, namespace);
  const loader = localeModules[key];
  if (!loader) {
    return Promise.reject(new Error(`Missing locale file: ${key}`));
  }
  return loader().then((mod) => mod.default ?? mod);
}

const lazyLocaleBackend = {
  type: 'backend',
  init() {},
  read(language, namespace, callback) {
    loadLocaleNamespace(language, namespace)
      .then((data) => callback(null, data))
      .catch((err) => callback(err, null));
  },
};

export default lazyLocaleBackend;
